
import {
	Component,
	Prop,
	Vue,
	Watch
} from "vue-property-decorator";
import UploadImg from '@/components/upload-img.vue';
import previewImg from '@/components/previewImg.vue';
import draggable from 'vuedraggable';
import ChoosePages from '@/components/choosepages/choosepages.vue';

import {
	imgHost
} from '@/utils/config'


@Component({
	name: 'sku-list',
	components: {
		UploadImg,
		draggable,
		previewImg,
		ChoosePages
	}
})
export default class ProductPictures extends Vue {
	@Prop({default:()=>{return []}}) list:any;
	@Prop({default:()=>{return []}}) hotData:any;
	private images: Array<string> = [];
	private imgHost = imgHost;
	private areaList: any = [];
	private moveIndex: number = -1;
	private canMove: boolean = false;
	private canDraw: boolean = false;
	private x: number = 0;
	private y: number = 0;
	private pagex: number = 0;
	private pagey: number = 0;
	private show: boolean = false;
	private choosemsg:any = {};
	private selectedIndex: number = -1;
	
	@Watch('list')
	private listChange(val: any){
		this.images = val;
	};

	@Watch('hotData')
	private hotDataChange(val: any){
		this.areaList = val;
	}

	private mounted(){
		this.images = this.list;
		this.areaList = this.hotData;
	}

	private uploadSuccess(list: Array<string>) {
		this.images = list;
		this.$emit('update', this.images);
	}
	private getdata(e){
	
		let dt = JSON.parse(JSON.stringify(e));
		let dt1 = {};
		let keys = ['label', 'pagetype', 'pagetypelabel', 'pageurl', 'Id'];
		for(let item in dt){
			if (keys.includes(item)){
				dt1[item] = dt[item];
			}
		}
		this.areaList[this.selectedIndex].data = dt.pagetype === 6 ? dt : dt1;
		this.show = false;
	}
	private handleChooseLink(index: number){
		this.selectedIndex = index;
		this.show = true;
		if (this.areaList[index].data.Id){
			this.choosemsg = this.areaList[index].data;
		}
	}

	private handleAddArea() {
		if (!this.images.length) {
			this.$message.error('请先上传图片');
			return;
		}

		this.areaList.push({
			clientWidth: 375,
			x: 0,
			y: 0,
			width: 0,
			height: 0,
			rgb: '',
			data: {},
			uid: this.guid()
		})
	}
	private handleStart(index) {
		let record = this.areaList[index];
		if (!record.rgb) {
			record.rgb = this.rgb();
		}
		this.moveIndex = index;
		this.canMove = true;
	}
	private handleClearArea(index) {
		let data = this.areaList[index];
		data.rgb = '';
		data.x = 0;
		data.y = 0;
		data.width = 0;
		data.height = 0;
		this.canMove = false;
		this.canDraw = false;
	}
	private handleDeleteItem(index) {
		this.areaList.splice(index, 1)
	}
	private handleClearChooseData(index){
		this.areaList[index].data = {}
	}

	private mousedown(event) {
		if (!this.canMove) return;
		// console.log(event)
		let scrollTop = document.querySelector('#content').scrollTop;
		this.x = event.layerX;
		this.y = scrollTop + event.layerY;
		this.pagex = event.pageX;
		this.pagey = event.pageY;

		this.canDraw = true;

		let data = this.areaList[this.moveIndex];
		data.x = this.x;
		data.y = this.y;
		data.width = 0;
		data.height = 0;
	}
	private mousemove(event) {
		
		if (!this.canMove || !this.canDraw) return;
		event.preventDefault();

		let curx = event.pageX - this.pagex;
		let cury = event.pageY - this.pagey;

		let data = this.areaList[this.moveIndex];

		data.width = Math.abs(curx);
		data.height = Math.abs(cury);
		data.x = (curx < 0 ? Math.abs(curx + this.x) : this.x);
		data.y = (cury < 0 ? Math.abs(cury + this.y) : this.y);

	}
	private mouseup() {
		this.canMove = false;
		this.canDraw = false;
	}
	private getStyles(record) {
		return `width: ${record.width}px;height:${record.height}px;left:${record.x}px;top:${record.y}px;background: ${record.rgb}`
	}
	private rgb() {
		let r = Math.floor(Math.random() * 256)
		let g = Math.floor(Math.random() * 256)
		let b = Math.floor(Math.random() * 256)
		return `rgb(${r},${g},${b})`
	}
	private guid() {
		var a = function () { return (65536 * (1 + Math.random()) | 0).toString(16).substring(1) };
		return a() + a() + "-" + a() + "-" + a() + "-" + a() + "-" + a() + a() + a()
	}

}
